module.exports = __webpack_public_path__ + "static/media/Energy Drink.cbdbb619.jpg";